import { render, staticRenderFns } from "./TransitionContainer.vue?vue&type=template&id=6bbabcb2&scoped=true"
import script from "./TransitionContainer.vue?vue&type=script&lang=js"
export * from "./TransitionContainer.vue?vue&type=script&lang=js"
import style0 from "./TransitionContainer.vue?vue&type=style&index=0&id=6bbabcb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbabcb2",
  null
  
)

export default component.exports